import React from 'react';

const CheckoutModal = ({
  cart,
  getCartTotal,
  deliverySlots,
  selectedSlot,
  setSelectedSlot,
  paymentMethod,
  setPaymentMethod,
  onClose,
  processPayment,
  deliveryAddresses,
  setShowAddAddress,
  handleSetDefaultAddress,
  selectedAddressId,
  setSelectedAddressId,
  // Coupon props
  appliedCoupon,
  couponDiscount,
  getFinalTotal,
  // Settings
  appSettings = { taxRate: 5, freeShippingThreshold: 500, standardShippingFee: 50 }
}) => {

    return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end z-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-t-3xl p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Checkout</h2>
          <button onClick={onClose} className="text-gray-500">
            ✕
          </button>
        </div>

        <div className="mb-6">
          <h3 className="font-semibold text-gray-800 mb-3">Delivery Address</h3>
          <div className="space-y-3 mb-4">
            {Array.isArray(deliveryAddresses) && deliveryAddresses.length > 0 ? (
              deliveryAddresses.map(addr => (
                <div
                  key={addr.id}
                  onClick={() => setSelectedAddressId && setSelectedAddressId(addr.id)}
                  className={`p-3 rounded-lg border cursor-pointer transition-all ${selectedAddressId === addr.id ? 'border-blue-600 bg-blue-50' : (addr.isDefault ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300')}`}>
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-semibold">{addr.label} {addr.isDefault && <span className="text-sm text-blue-600 font-medium">(Default)</span>}</p>
                      <p className="text-sm text-gray-600">{addr.recipient_name} • {addr.phone}</p>
                      <p className="text-sm text-gray-500 mt-1">{addr.address}, {addr.city} {addr.pincode}</p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      {selectedAddressId === addr.id && (
                        <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-white text-xs">✓</div>
                      )}
                      {!addr.isDefault && (
                        <button onClick={(e) => { e.stopPropagation(); handleSetDefaultAddress && handleSetDefaultAddress(addr.id); }} className="text-sm text-blue-600">Set Default</button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-sm text-gray-500">No delivery addresses found.</div>
            )}
            <button onClick={() => setShowAddAddress && setShowAddAddress(true)} className="text-sm text-blue-600">+ Add New Address</button>
          </div>

          <h3 className="font-semibold text-gray-800 mb-3">Select Delivery Slot</h3>
          <div className="space-y-2">
            {deliverySlots.map(slot => (
              <button
                key={slot.id}
                onClick={() => setSelectedSlot(slot.id)}
                className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                  selectedSlot === slot.id
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 hover:border-blue-300'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{slot.icon}</span>
                  <div className="text-left">
                    <p className="font-semibold text-gray-800">{slot.label}</p>
                    <p className="text-sm text-gray-500">{slot.time}</p>
                  </div>
                </div>
                {selectedSlot === slot.id && (
                  <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <h3 className="font-semibold text-gray-800 mb-3">Payment Method</h3>
          <div className="space-y-2">
            <button
              onClick={() => setPaymentMethod('cod')}
              className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                paymentMethod === 'cod'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">💵</span>
                <div className="text-left">
                  <p className="font-semibold text-gray-800">Cash on Delivery</p>
                  <p className="text-sm text-gray-500">Pay when you receive</p>
                </div>
              </div>
              {paymentMethod === 'cod' && (
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </button>

            <button
              onClick={() => setPaymentMethod('upi')}
              className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                paymentMethod === 'upi'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">📱</span>
                <div className="text-left">
                  <p className="font-semibold text-gray-800">UPI Payment</p>
                  <p className="text-sm text-gray-500">PhonePe, GPay, Paytm</p>
                </div>
              </div>
              {paymentMethod === 'upi' && (
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </button>

            <button
              onClick={() => setPaymentMethod('card')}
              className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                paymentMethod === 'card'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">💳</span>
                <div className="text-left">
                  <p className="font-semibold text-gray-800">Credit/Debit Card</p>
                  <p className="text-sm text-gray-500">Visa, Mastercard, Rupay</p>
                </div>
              </div>
              {paymentMethod === 'card' && (
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </button>

            <button
              onClick={() => setPaymentMethod('wallet')}
              className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                paymentMethod === 'wallet'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">👛</span>
                <div className="text-left">
                  <p className="font-semibold text-gray-800">Wallet</p>
                  <p className="text-sm text-gray-500">Paytm, Amazon Pay</p>
                </div>
              </div>
              {paymentMethod === 'wallet' && (
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </button>
          </div>
        </div>

        {/* Free Shipping Motivation Message */}
        {(() => {
          const cartTotal = getCartTotal() - (couponDiscount || 0);
          const remaining = appSettings.freeShippingThreshold - cartTotal;
          
          if (cartTotal >= appSettings.freeShippingThreshold) {
            return (
              <div className="bg-gradient-to-r from-green-50 to-green-100 border-2 border-green-400 rounded-xl p-3 mb-4 flex items-center gap-2">
                <div className="text-2xl">🎉</div>
                <div className="flex-1">
                  <p className="font-bold text-green-700 text-sm">You qualify for FREE shipping!</p>
                  <p className="text-xs text-green-600">No delivery charges</p>
                </div>
              </div>
            );
          } else if (remaining > 0) {
            return (
              <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-400 rounded-xl p-3 mb-4 flex items-center gap-2">
                <div className="text-2xl">🚚</div>
                <div className="flex-1">
                  <p className="font-bold text-blue-700 text-sm">Add ₹{remaining.toFixed(0)} more for FREE shipping!</p>
                  <p className="text-xs text-blue-600">Save ₹{appSettings.standardShippingFee} on delivery</p>
                </div>
              </div>
            );
          }
        })()}

        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Subtotal</span>
            <span className="font-semibold">₹{getCartTotal()}</span>
          </div>
          {appliedCoupon && couponDiscount > 0 && (
            <div className="flex justify-between mb-2">
              <span className="text-green-600">Coupon Discount ({appliedCoupon.code})</span>
              <span className="font-semibold text-green-600">-₹{couponDiscount}</span>
            </div>
          )}
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Shipping</span>
            <span className="font-semibold">
              {getCartTotal() >= appSettings.freeShippingThreshold ? (
                <span className="text-green-600">Free</span>
              ) : (
                `₹${appSettings.standardShippingFee}`
              )}
            </span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="text-gray-600">Tax (GST {appSettings.taxRate}%)</span>
            <span className="font-semibold">₹{(getCartTotal() * (appSettings.taxRate / 100)).toFixed(2)}</span>
          </div>
          <div className="border-t pt-2 mt-2">
            <div className="flex justify-between">
              <span className="text-lg font-bold">Total</span>
              <span className="text-lg font-bold text-blue-600">₹{getFinalTotal ? getFinalTotal() : getCartTotal()}</span>
            </div>
          </div>
        </div>

        <button 
          onClick={processPayment}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:from-blue-600 hover:to-blue-700 transition-all">
          Confirm & Pay ₹{getFinalTotal ? getFinalTotal() : getCartTotal()}
        </button>
      </div>
    </div>
  );
};

export default CheckoutModal;   